// extracted by extract-css-chunks-webpack-plugin
module.exports = {"resellerSelection":"Vma7qmNr6CrZq7dM24rS"};